// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"4832e716","85":"b8d0666d","127":"5286f969","136":"50e157c3","152":"c74d69aa","207":"6317c4ce","285":"38206c35","309":"bad2e480","381":"e162fa1b","621":"608b5478","645":"d3b14837","810":"e24afae8"}[chunkId] + ".chunk.js";
};